import React, { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config";

const GestionarTituloLogin = () => {
  const [titulo, setTitulo] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    axios.get(`${API_URL}/api/configuracion-login`).then((res) => {
      setTitulo(res.data.titulo || "");
    });
  }, []);

  const guardar = async () => {
    if (!titulo.trim()) return;
    setGuardando(true);
    setMensaje("");
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API_URL}/api/configuracion-login`,
        { titulo },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMensaje("✅ Título actualizado correctamente");
    } catch (err) {
      setMensaje("❌ " + (err.response?.data?.message || "Error al guardar"));
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>📝 Título del Login</h2>
      <p style={{ color: "#64748b", marginBottom: 20 }}>
        Este es el texto grande que aparece arriba en la pantalla de inicio de sesión (ej. "CDA
        Corte 3 2026").
      </p>

      <input
        type="text"
        value={titulo}
        onChange={(e) => setTitulo(e.target.value)}
        placeholder="Ej: CDA Corte 3 2026"
        style={{
          width: "100%",
          padding: "10px 14px",
          borderRadius: 10,
          border: "1px solid #cbd5e1",
          marginBottom: 16,
          fontSize: 15,
        }}
      />

      <button
        onClick={guardar}
        disabled={guardando}
        style={{
          padding: "10px 20px",
          borderRadius: 10,
          border: "none",
          background: "#2563eb",
          color: "#fff",
          fontWeight: 600,
          cursor: guardando ? "default" : "pointer",
        }}
      >
        {guardando ? "Guardando..." : "Guardar"}
      </button>

      {mensaje && <p style={{ marginTop: 14, fontWeight: 600 }}>{mensaje}</p>}
    </div>
  );
};

export default GestionarTituloLogin;
